(function () {
  if (customElements.get('delivery-checker')) return;

  function cleanPincode(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 6);
  }

  function getPincodeZone(pin, root) {
    var p = parseInt(pin, 10);

    if (
      (p >= 110001 && p <= 110096) ||
      (p >= 201001 && p <= 201310) ||
      (p >= 122001 && p <= 122508) ||
      (p >= 124001 && p <= 124507) ||
      (p >= 131001 && p <= 131402) ||
      (p >= 121001 && p <= 121106) ||
      (p >= 245001 && p <= 245412)
    ) {
      return Number(root.dataset.zone1 || 2);
    }

    if (
      (p >= 200001 && p <= 285205) ||
      (p >= 125001 && p <= 136156) ||
      (p >= 140001 && p <= 160059) ||
      (p >= 301001 && p <= 345034) ||
      (p >= 246001 && p <= 263680) ||
      (p >= 170001 && p <= 177213)
    ) {
      return Number(root.dataset.zone2 || 3);
    }

    if (
      (p >= 450001 && p <= 488776) ||
      (p >= 800001 && p <= 855117) ||
      (p >= 360001 && p <= 396590) ||
      (p >= 400001 && p <= 445402) ||
      (p >= 490001 && p <= 497778) ||
      (p >= 700001 && p <= 743710)
    ) {
      return Number(root.dataset.zone3 || 4);
    }

    return Number(root.dataset.defaultDays || 5);
  }

  function getDeliveryDate(days, showWeekday) {
    var date = new Date();
    date.setDate(date.getDate() + Number(days || 0));

    return date.toLocaleDateString('en-IN', {
      weekday: showWeekday ? 'short' : undefined,
      month: 'short',
      day: 'numeric',
    });
  }

  customElements.define(
    'delivery-checker',
    class DeliveryChecker extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;
        this._initialized = true;

        this.input = this.querySelector('[data-pincode-input]');
        this.checkBtn = this.querySelector('[data-check-btn]');
        this.form = this.querySelector('[data-pincode-form]');
        this.result = this.querySelector('[data-delivery-result]');
        this.note = this.querySelector('[data-pincode-note]');
        this.error = this.querySelector('[data-pincode-error]');
        this.displayPin = this.querySelector('[data-display-pin]');
        this.deliveryDate = this.querySelector('[data-delivery-date]');
        this.changeBtn = this.querySelector('[data-change-btn]');

        if (!this.input || !this.checkBtn || !this.form || !this.result) return;

        this.rememberPincode = this.dataset.remember === 'true';
        this.showWeekday = this.dataset.showWeekday === 'true';
        this.storageKey = 'delivery_checker_pin_' + (this.dataset.blockId || 'default');

        this.checkBtn.addEventListener('click', this.checkPincode.bind(this));
        this.input.addEventListener('input', this.onInput.bind(this));
        this.input.addEventListener('keydown', this.onKeydown.bind(this));

        if (this.changeBtn) {
          this.changeBtn.addEventListener('click', this.changePincode.bind(this));
        }

        if (this.rememberPincode) {
          try {
            var savedPin = localStorage.getItem(this.storageKey);
            if (savedPin && cleanPincode(savedPin).length === 6) {
              this.input.value = cleanPincode(savedPin);
              this.showResult(cleanPincode(savedPin));
            }
          } catch (e) {}
        }
      }

      onInput() {
        this.input.value = cleanPincode(this.input.value);
        this.hideError();
      }

      onKeydown(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.checkPincode();
        }
      }

      showError() {
        if (this.error) this.error.hidden = false;
      }

      hideError() {
        if (this.error) this.error.hidden = true;
      }

      showResult(pin) {
        var days = getPincodeZone(pin, this);

        this.form.hidden = true;
        if (this.note) this.note.hidden = true;
        if (this.displayPin) this.displayPin.textContent = pin;
        if (this.deliveryDate) {
          this.deliveryDate.textContent = getDeliveryDate(days, this.showWeekday);
        }

        this.result.hidden = false;
        this.hideError();

        if (this.rememberPincode) {
          try {
            localStorage.setItem(this.storageKey, pin);
          } catch (e) {}
        }
      }

      checkPincode() {
        var pin = cleanPincode(this.input.value);
        this.input.value = pin;

        if (pin.length !== 6) {
          this.showError();
          return;
        }

        this.showResult(pin);
      }

      changePincode() {
        this.form.hidden = false;
        if (this.note) this.note.hidden = false;
        this.input.value = '';
        this.result.hidden = true;
        this.hideError();

        if (this.rememberPincode) {
          try {
            localStorage.removeItem(this.storageKey);
          } catch (e) {}
        }

        setTimeout(
          function () {
            this.input.focus();
          }.bind(this),
          50
        );
      }
    }
  );
})();
